import { render, staticRenderFns } from "./UIMultiselect.vue?vue&type=template&id=e9ba35d4&scoped=true&"
import script from "./UIMultiselect.vue?vue&type=script&lang=js&"
export * from "./UIMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./UIMultiselect.vue?vue&type=style&index=0&lang=postcss&"
import style1 from "./UIMultiselect.vue?vue&type=style&index=1&id=e9ba35d4&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../.yarn/$$virtual/vue-loader-virtual-a9dd69dad6/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ba35d4",
  null
  
)

export default component.exports